module.exports = __webpack_public_path__ + "static/media/jaime.d5bc37e6.jpg";